import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { Button as BaseButton } from "sprout-ui-dom";
import { Box, Flex, Text } from "sprout-ui-primitives";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { ACTIONS, useActionRegistryNavigation, useNavigationListContext } from "@sprout/list-navigation";
import styled from "styled-components";
import { media } from "sprout-ui-theme";
import sortStarredTopics from "@sprout/client-lib/dist/sortStarredTopics";
import { getItemUrl } from "sprout-lib";
import Divider from "sprout-ui-dom/dist/Divider";
import RenderIfChildExists from "../../../RenderIfChildExists";
function getStarredURL(topic) {
    var ref;
    if (!topic) return undefined;
    return getItemUrl(topic, (ref = topic.rootTopicOrSelf) === null || ref === void 0 ? void 0 : ref.owner);
}
const Button = styled(BaseButton)`
  position: relative;
  min-width: 0;
`;
const AppBarAppDesktopNavButtonKeybinding = styled(Box).attrs({
    as: "span"
})`
  top: 0;
  right: 4px;

  display: none;

  ${media.up("medium", "pointer")} {
    display: initial;
  }
`;
const AppBarAppDesktopNavPinnedWrapper = styled(Flex)`
  min-width: 0;
  ${media.down("960px")} {
    display: none;
  }
`;
const AppBarAppDesktopNavButton = (props)=>{
    const { action , label  } = props;
    const { dispatchCommand  } = useNavigationListContext();
    const handleClick = useCallback(()=>{
        dispatchCommand(action, null);
    }, [
        action,
        dispatchCommand
    ]);
    const actionSpec = useMemo(()=>{
        return ACTIONS.find(({ command  })=>command === action);
    }, [
        action
    ]);
    const { keybindingForDisplay  } = actionSpec || {};
    return /*#__PURE__*/ _jsxs(Button, {
        onClick: handleClick,
        variant: "flat",
        color: "black.87",
        children: [
            /*#__PURE__*/ _jsx(Text, {
                as: "span",
                fontWeight: "medium",
                pr: "2px",
                truncate: true,
                children: label
            }),
            keybindingForDisplay && /*#__PURE__*/ _jsx(AppBarAppDesktopNavButtonKeybinding, {
                position: "absolute",
                as: Text,
                fontWeight: "medium",
                color: "black.40",
                children: keybindingForDisplay
            })
        ]
    });
};
const AppBarAppDesktopNav = ()=>{
    const currentUser = useCurrentUser();
    // const startPage = currentUser?.userSetting?.startPage;
    const { starredTopics , starredTopicIds  } = currentUser || {};
    const { first , second , third  } = useMemo(()=>{
        const [one, two, three] = sortStarredTopics((starredTopics === null || starredTopics === void 0 ? void 0 : starredTopics.nodes) || [], starredTopicIds || []);
        return {
            first: one ? {
                topic: one,
                url: getStarredURL(one)
            } : undefined,
            second: two ? {
                topic: two,
                url: getStarredURL(two)
            } : undefined,
            third: three ? {
                topic: three,
                url: getStarredURL(three)
            } : undefined
        };
    }, [
        starredTopicIds,
        starredTopics
    ]);
    useActionRegistryNavigation("GO_PIN_1", (first === null || first === void 0 ? void 0 : first.url) || "/", {
        skip: !first
    });
    useActionRegistryNavigation("GO_PIN_2", (second === null || second === void 0 ? void 0 : second.url) || "/", {
        skip: !second
    });
    useActionRegistryNavigation("GO_PIN_3", (third === null || third === void 0 ? void 0 : third.url) || "/", {
        skip: !third
    });
    return /*#__PURE__*/ _jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        minWidth: "0",
        children: [
            /*#__PURE__*/ _jsx(AppBarAppDesktopNavButton, {
                action: "GO_AGENDA",
                label: "Agenda"
            }),
            /*#__PURE__*/ _jsx(AppBarAppDesktopNavButton, {
                action: "GO_PRIORITIES",
                label: "Priorities"
            }),
            /*#__PURE__*/ _jsx(AppBarAppDesktopNavButton, {
                action: "GO_TREES",
                label: "Trees"
            }),
            /*#__PURE__*/ _jsxs(RenderIfChildExists, {
                component: /*#__PURE__*/ _jsx(AppBarAppDesktopNavPinnedWrapper, {
                    alignItems: "center"
                }),
                children: [
                    (first || second || third) && /*#__PURE__*/ _jsx(Divider, {
                        width: "1px",
                        height: "20px",
                        bg: "black.12",
                        ml: 2
                    }),
                    first && /*#__PURE__*/ _jsx(AppBarAppDesktopNavButton, {
                        action: "GO_PIN_1",
                        label: first.topic.title || "No title"
                    }),
                    second && /*#__PURE__*/ _jsx(AppBarAppDesktopNavButton, {
                        action: "GO_PIN_2",
                        label: second.topic.title || "No title"
                    }),
                    third && /*#__PURE__*/ _jsx(AppBarAppDesktopNavButton, {
                        action: "GO_PIN_3",
                        label: third.topic.title || "No title"
                    })
                ]
            })
        ]
    });
};
export default AppBarAppDesktopNav;
